/**
 * @param {String} str
 * @returns {String}
 */
export function captializeFirstLetter(str) {
  return str[0].toUpperCase() + str.slice(1);
}